<template>
  <div class="pa-6 mt-0" style="width: 100%">
    <div class="mb-6">
      <div class="component-title">Chấm bài tự động</div>
    </div>

    <v-card outlined class="pa-6 mb-6 elevation-0">
      <MarkOmrFilter @onFilterChanged="onFilterChanged" />
    </v-card>

    <div v-if="action.state === 'select'" class="elevation-0">
      <StudentBlankView />
    </div>
    <v-card v-else outlined class="elevation-0">
      <MarkAllTableOmr :query="query" :subject="subject" :exam="exam" />
    </v-card>
  </div>
</template>
<script>
import MarkOmrFilter from '@/modules/exam/MarkOmrFilter.vue'
import StudentBlankView from '@/components/basic/StudentBlankView.vue'
import MarkTable from '@/modules/exam/MarkTable.vue'
import MarkAllTableOmr from '../../modules/exam/MarkAllTableOmr.vue'

export default {
  components: {
    StudentBlankView,
    MarkOmrFilter,
    MarkTable,
    MarkAllTableOmr
  },
  data() {
    return {
      action: {
        state: 'select'
      },
      query: {},
      roomSubject: {},
      subject: {},
      exam: {},
      fileName: ''
    }
  },
  computed: {},
  methods: {
    onFilterChanged(params, roomSubject, fileName, subject, exam) {
      console.log(params)
      this.action.state = 'filtered'
      this.query = params
      this.roomSubject = roomSubject
      this.fileName = fileName
      this.subject = subject
      this.exam = exam
    }
  }
}
</script>
<style scoped>
.component-title {
  color: #0d47a1;
  font-family: 'Roboto';
  font-style: normal;
  font-weight: 500;
  font-size: 24px;
  line-height: 28px;
}
</style>
